import ReferralBonusesPage from './ReferralBonusesPage';

export default ReferralBonusesPage; 